module.exports = { id: "support", url: "/build/app/img/symbols.svg#support", viewBox: "", toString: function() { return this.url; } };